/* Collection SEO block — tabs and FAQ show-more.
   Pattern follows bm-collection-tab.js: IIFE, guard early, no dependencies.
   Scoped per instance so more than one block on a page cannot cross-wire. */
(function () {
  "use strict";

  var roots = document.querySelectorAll("[data-bmcs-tabs]");
  if (!roots.length) return;

  Array.prototype.forEach.call(roots, function (root) {
    var tabs = root.querySelectorAll("[data-bmcs-tab]");
    var panels = root.querySelectorAll("[data-bmcs-panel]");

    /* ── Tabs ── */
    function activate(name) {
      Array.prototype.forEach.call(tabs, function (t) {
        var on = t.getAttribute("data-bmcs-tab") === name;
        t.classList.toggle("is-active", on);
        t.setAttribute("aria-selected", on ? "true" : "false");
      });
      Array.prototype.forEach.call(panels, function (p) {
        p.classList.toggle("is-active", p.getAttribute("data-bmcs-panel") === name);
      });
    }

    Array.prototype.forEach.call(tabs, function (tab) {
      tab.addEventListener("click", function () {
        activate(tab.getAttribute("data-bmcs-tab"));
      });

      /* Left/right arrows move between tabs, per the tablist pattern. */
      tab.addEventListener("keydown", function (e) {
        if (e.key !== "ArrowRight" && e.key !== "ArrowLeft") return;
        var list = Array.prototype.slice.call(tabs);
        var i = list.indexOf(tab);
        var next = e.key === "ArrowRight" ? i + 1 : i - 1;
        if (next < 0) next = list.length - 1;
        if (next >= list.length) next = 0;
        list[next].focus();
        activate(list[next].getAttribute("data-bmcs-tab"));
        e.preventDefault();
      });
    });

    /* ── FAQ show more / fewer ──
       Rows past the third carry .is-extra and are hidden in CSS. Only the class
       is toggled — the answers stay in the DOM so the FAQ schema keeps matching
       the page content. */
    var moreBtn = root.querySelector("[data-bmcs-more]");
    if (!moreBtn) return;

    var extras = root.querySelectorAll(".bmcs-q.is-extra");
    var label = moreBtn.querySelector("[data-bmcs-more-label]");
    var closedLabel = label ? label.textContent : "Show more";

    moreBtn.addEventListener("click", function () {
      var open = moreBtn.getAttribute("data-open") === "true";
      var next = !open;
      moreBtn.setAttribute("data-open", String(next));
      moreBtn.setAttribute("aria-expanded", String(next));
      Array.prototype.forEach.call(extras, function (row) {
        row.classList.toggle("is-shown", next);
      });
      if (label) label.textContent = next ? "Show fewer" : closedLabel;
    });
  });
})();
